import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import PasswordField from './PasswordField';
import { parseBoolean, parseRequired } from '../../../../Utils/form.util';

loadDOMComponent({
	selector: 'react-password-field',
	callback: ({ container, context, props }: any) => {
		const name = container.getAttribute('name');
		const placeholder = container.getAttribute('placeholder');
		const value = container.getAttribute('value');
		const netteRules = container.getAttribute('data-nette-rules');
		const required = parseRequired(container.getAttribute('required'));
		const checklist = JSON.parse(container.getAttribute('checklist') || {});
		const loadChecklist = parseBoolean(container.getAttribute('loadChecklist'));

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<PasswordField
						name={name}
						placeholder={placeholder}
						value={value}
						netteRules={netteRules}
						isRequired={required}
						checklist={checklist}
						loadChecklist={loadChecklist}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
